
"use client"
import { AppProgressBar as ProgressBar } from 'next-nprogress-bar'

const MyProgressBar = () => {
    return (
        <ProgressBar
            height="3px"
            color="#ffdb4d"
            options={{ showSpinner: false }}
        />
    )
}

export default MyProgressBar